import { ListItemBox } from "lib/@components/ListItemBox"
import { Box, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function Conflict() {
    return (
        <ListItemBox sx={{ lineHeight: 0 }} spacing={1} direction="row" alignItems="center">
            <Box sx={{ color: "warning.main" }}>
                <Iconify icon="mdi:warning" />
            </Box>
            <Typography sx={{ color: "text.secondary" }} variant="caption">
                Changed in both versions.
            </Typography>
        </ListItemBox>
    )
}
